/** TanStack Query key for `getPreferences()` — post-login redirect + invalidation on save. */
export const USER_PREFERENCES_QUERY_KEY = ["user", "preferences"] as const;
